<template>

<app-view-list-field :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

		value: function() {

			var parts = this.item.user && this.item.user.parts
			if (!parts || !parts.length) return '-'
			var texts = parts.map(function(p) { return p.text }).filter(function(t) { return t })
			return texts.length ? texts.join(' / ') : '-'

		}

	}

}

</script>
